import type React from 'react'

export interface ToolUseIndicatorProps {
  readonly toolNames: readonly string[]
}

function ToolIcon(): React.ReactElement {
  return (
    <svg
      aria-hidden="true"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2.5a3 3 0 0 1 3.93 3.93L12.5 4.5l-1.5 1.5 1.93 1.93a3 3 0 0 1-3.93-3.93L4.5 8.5l-2 2a1.414 1.414 0 1 0 2 2l2-2 4.5-4.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ToolUseIndicator({ toolNames }: ToolUseIndicatorProps): React.ReactElement {
  const label = toolNames.join(', ')
  return (
    <div
      className="inline-flex items-center gap-2 text-neutral-600 italic"
      data-testid="tool-use-indicator"
    >
      <ToolIcon />
      <span>{toolNames.length === 1 ? 'Tool used' : 'Tools used'}: {label}</span>
    </div>
  )
}
